import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Divider
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import HomeIcon from "@mui/icons-material/Home";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

import api from "../../api";

const DetalleCombustible = ({ selectedCombustible, handleDetailClose }) => {
  const [combustible, setCombustible] = useState(null);
  const [vehiculoInfo, setVehiculoInfo] = useState(null);
  const [conductorInfo, setConductorInfo] = useState(null);

  useEffect(() => {
    if (selectedCombustible) {
      api.get(`combustibles/${selectedCombustible.id}/`)
        .then((response) => {
          const data = response.data;
          setCombustible(data);

          // Fetch conductor if only ID is returned
          if (data.conductor && typeof data.conductor === "number") {
            api.get(`conductores/${data.conductor}/`)
              .then((res) => setConductorInfo(res.data))
              .catch(() => console.warn("No se pudo cargar el conductor."));
          }

          // Fetch vehiculo if only ID is returned
          if (data.vehiculo && typeof data.vehiculo === "number") {
            api.get(`vehiculos/${data.vehiculo}/`)
              .then((res) => setVehiculoInfo(res.data))
              .catch(() => console.warn("No se pudo cargar el vehículo."));
          }
        })
        .catch(() => alert("Error al cargar detalles del consumo."));
    }
  }, [selectedCombustible]);

  // Helper to format date
  const formatDateTime = (datetimeStr) => {
    if (!datetimeStr) return "No disponible";
    const date = new Date(datetimeStr);
    return date.toLocaleString();
  };

  return (
    <Dialog
      open={!!selectedCombustible}
      onClose={handleDetailClose}
      fullWidth
      maxWidth="md"
    >
      <DialogContent dividers sx={{ padding: "20px", backgroundColor: "#f4f6f9" }}>
        {combustible ? (
          <Card sx={{ boxShadow: 3, borderRadius: "8px", padding: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#152d51",
                display: "flex",
                alignItems: "center",
                marginBottom: 2
              }}
            >
              <LocalGasStationIcon sx={{ marginRight: 1, color: "#152d51" }} />
              <strong>Detalles del Consumo</strong>
            </Typography>

            <Divider sx={{ my: 2 }} />
            <CardContent>
              <Grid container spacing={2}>

                {/* Left Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem
                    icon={<CalendarTodayIcon />}
                    label="Fecha y Hora"
                    value={formatDateTime(combustible.fecha_y_hora)}
                  />
                  <InfoItem
                    icon={<HomeIcon />}
                    label="Domicilio"
                    value={combustible.domicilio || "No disponible"}
                  />
                  <InfoItem
                    icon={<LocationCityIcon />}
                    label="Localidad"
                    value={combustible.localidad || "No disponible"}
                  />
                  <InfoItem
                    icon={<MapIcon />}
                    label="Provincia"
                    value={combustible.provincia || "No disponible"}
                  />
                  <InfoItem
                    icon={<LocalGasStationIcon />}
                    label="Producto"
                    value={combustible.producto || "No disponible"}
                  />
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem
                    icon={<AccountCircleIcon />}
                    label="Conductor"
                    value={
                      conductorInfo
                        ? `${conductorInfo.nombre} ${conductorInfo.apellido ?? ""}`.trim()
                        : (typeof combustible?.conductor === "number"
                          ? `ID: ${combustible.conductor}`
                          : "No asignado")
                    }
                  />
                  <InfoItem
                    icon={<LocalGasStationIcon />}
                    label="Vehículo"
                    value={
                      combustible?.vehiculo_nombre ||
                      (typeof combustible?.vehiculo === "number" ? `ID: ${combustible.vehiculo}` : "No asignado")
                    }
                  />
                  <InfoItem
                    icon={<LocalGasStationIcon />}
                    label="Litros Unidades"
                    value={combustible.litros_unidades !== null ? `${combustible.litros_unidades} L` : "No disponible"}
                  />
                  <InfoItem
                    icon={<MonetizationOnIcon />}
                    label="Importe Total (YER)"
                    value={combustible.imp_tot_yer !== null ? `$${combustible.imp_tot_yer}` : "No disponible"}
                  />
                </Grid>

              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No se encontraron detalles del consumo.
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "16px", backgroundColor: "#f4f6f9" }}>
        <Button
          onClick={handleDetailClose}
          variant="contained"
          sx={{ backgroundColor: "#152d51" }}
          fullWidth
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const InfoItem = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      marginBottom: 1,
      backgroundColor: "#f4f6f9",
      padding: 1.5,
      borderRadius: "8px"
    }}
  >
    {icon && <Box sx={{ marginRight: 1, color: "#152d51" }}>{icon}</Box>}
    <Typography variant="subtitle1">
      <strong>{label}:</strong> {value}
    </Typography>
  </Box>
);

export default DetalleCombustible;
